import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Breadcrumbs } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import Jumbotron from '../../components/Basics/Jumbotron'
import { SECTORS_DICTIONARY } from './BuyersSectors.utils'
import {
  ArrowRight,
  Card,
  Content,
  Description,
  GridContainer,
  GridItem,
  Icon,
  JumboDescription,
  JumboTitle,
  Root,
  Text,
  Title
} from './BuyersSectors.styles'

/**
 * The BuyersSectors' container.
 */
const BuyersSectors = () => {
  const navigate = useNavigate()
  const { sectors = [] } = useSelector(state => state.topNavbar)
  const handleRedirectToSector = sectorSlug => () => navigate(routes.sector.replace(/:sectorSlug/, sectorSlug))
  const filteredSectors = useMemo(() => sectors.filter(sector => sector.id !== 8), [sectors])

  return (
    <Root>
      <GridContainer>
        <GridItem xs={12}>
          <Jumbotron>
            <Breadcrumbs>
              <Breadcrumb to={routes.root} variant="link">
                Datos Abiertos
              </Breadcrumb>
              <Breadcrumb>Organismos Compradores</Breadcrumb>
            </Breadcrumbs>
            <JumboTitle>Organismos compradores</JumboTitle>
            <JumboDescription>
              Corresponden a la entidades del Estado que adquieren bienes y servicios para el
              <br /> desarrollo de sus funciones a través de Mercado Público.
            </JumboDescription>
          </Jumbotron>
        </GridItem>
      </GridContainer>
      <Content>
        <GridContainer padding="0 0 23px">
          <GridItem xs={12}>
            <Title>Organismos compradores por sector del Estado</Title>
          </GridItem>
        </GridContainer>
        <GridContainer padding="0 0 28px">
          <GridItem xs={12}>
            <Description>
              Accede a la información de compras realizadas por cada uno de los sectores pertenecientes al Estado.
            </Description>
          </GridItem>
        </GridContainer>
        <GridContainer padding="0 0 22px" spacing={2}>
          {filteredSectors.map(sector => (
            <GridItem key={sector.id} md={3} xs={12}>
              <Card
                enableHover
                color="blank"
                elevation="1"
                height="76px"
                onClick={handleRedirectToSector(SECTORS_DICTIONARY[sector.id]?.slug)}
              >
                <GridContainer alignItems="center" height="100%">
                  <Icon src={SECTORS_DICTIONARY[sector.id]?.icon} />
                  <Text>{sector.name}</Text>
                  <ArrowRight />
                </GridContainer>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      </Content>
    </Root>
  )
}

export default BuyersSectors
